import routerOptions0 from "/build/e08b1ba2-1aac-4ce5-8f34-3f53ff87f8c4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}